import { PartitionLoopIncrementJCountState } from "./PartitionLoopIncrementJCountState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep";
import { IQuickSortContext } from "../../IQuickSortContext";

export class PartitionLoopSwapICountJCount implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionLoopSwapICountJCount;

  Description = "Swap element at i index with element at j index";

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void { 
    if (this._context && this._context.ICount !== undefined && 
        this._context.JCount !== undefined && this._context.Numbers !== undefined) {
      
      let temp : number = this._context.Numbers[this._context.ICount];
      this._context.Numbers[this._context.ICount] = this._context.Numbers[this._context.JCount];
      this._context.Numbers[this._context.JCount] = temp;
    }
  }

  Undo(): void {
    if (this._context && this._context.ICount !== undefined && 
      this._context.JCount !== undefined && this._context.Numbers !== undefined) {
    
      let temp : number = this._context.Numbers[this._context.ICount];
      this._context.Numbers[this._context.ICount] = this._context.Numbers[this._context.JCount];
      this._context.Numbers[this._context.JCount] = temp;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      this._context.TransitionTo(new PartitionLoopIncrementJCountState());
    }
  }
}